import { useState } from 'react';
import Button from '../components/Button';
import { addAvailability, updateAvailability, deleteAvailability } from '../firebase/services';

function Availabilities({ availabilities, setAvailabilities, ladies }) {
    const [isEditing, setIsEditing] = useState(null);
    const [formData, setFormData] = useState({ timeRange: '', ladies: [] });

    const handleAdd = async () => {
        try {
            if (isEditing === "new") {
                const newAvailability = await addAvailability(formData);
                setAvailabilities([...availabilities, newAvailability]);
            } else if (isEditing !== null) {
                const updatedAvailability = await updateAvailability(availabilities[isEditing].id, formData);
                const updatedAvailabilities = [...availabilities];
                updatedAvailabilities[isEditing] = updatedAvailability;
                setAvailabilities(updatedAvailabilities);
            }
            setFormData({ timeRange: '', ladies: [] });
            setIsEditing(null);
        } catch (error) {
            console.error("Error saving availability:", error);
        }
    };

    const handleDelete = async (index) => {
        try {
            await deleteAvailability(availabilities[index].id);
            const newAvailabilities = availabilities.filter((_, i) => i !== index);
            setAvailabilities(newAvailabilities);
        } catch (error) {
            console.error("Error deleting availability:", error);
        }
    };

    const handleEdit = (availability, index) => {
        setIsEditing(index);
        setFormData(availability);
    };

    const handleLadySelection = (e) => {
        const value = e.target.value;
        if (!formData.ladies.includes(value)) {
            setFormData({ ...formData, ladies: [...formData.ladies, value] });
        }
    };

    const removeLady = (ladyToRemove) => {
        setFormData({
            ...formData,
            ladies: formData.ladies.filter(lady => lady !== ladyToRemove)
        });
    };

    // Lady options dropdown
    const ladyOptions = ladies.map((lady) => (
        <option key={lady.id} value={lady.name}>
            {lady.name}
        </option>
    ));

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h1 className="text-3xl font-bold text-white">Manage Availabilities</h1>
                <Button onClick={() => setIsEditing('new')}>Add New Availability</Button>
            </div>

            {/* Form */}
            {isEditing !== null && (
                <div className="bg-gray-900 p-6 rounded-lg space-y-4">
                    <input
                        type="text"
                        placeholder="Time Range"
                        className="w-full p-2 rounded bg-gray-800 text-white"
                        value={formData.timeRange}
                        onChange={e => setFormData({ ...formData, timeRange: e.target.value })}
                    />
                    <select
                        className="w-full p-2 rounded bg-gray-800 text-white"
                        onChange={handleLadySelection}
                        value=""
                    >
                        <option value="">Select ladies...</option>
                        {ladyOptions}
                    </select>
                    <div className="flex flex-wrap gap-2">
                        {formData.ladies.map((lady, index) => (
                            <div key={index} className="bg-gray-700 px-3 py-1 rounded-full flex items-center">
                                <span className="mr-2 text-gray-200">{lady}</span>
                                <button onClick={() => removeLady(lady)} className="text-red-400">×</button>
                            </div>
                        ))}
                    </div>
                    <div className="flex space-x-4">
                        <Button onClick={handleAdd}>Save</Button>
                        <Button variant="secondary" onClick={() => setIsEditing(null)}>Cancel</Button>
                    </div>
                </div>
            )}

            {/* Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {availabilities.map((availability, index) => (
                    <div key={index} className="bg-gray-900 p-6 rounded-lg space-y-4">
                        <h3 className="text-xl font-bold text-white">{availability.timeRange}</h3>
                        <div className="flex flex-wrap gap-2">
                            {availability.ladies.map((lady, ladyIndex) => (
                                <span key={ladyIndex} className="bg-gray-200 px-3 py-1 rounded-full">
                                    {lady}
                                </span>
                            ))}
                        </div>
                        <div className="flex space-x-4">
                            <Button variant="secondary" onClick={() => handleEdit(availability, index)}>
                                Edit
                            </Button>
                            <Button variant="danger" onClick={() => handleDelete(index)}>
                                Delete
                            </Button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Availabilities;